export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_DATA'
export const FETCH_PRODUCTS_SECCESS = 'FETCH_PRODUCTS_SECCESS'
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE'